///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportServiceCategory = Meevo.Plugins.Reports.IReportServiceCategory;


    export class ReportServiceCategoriesCollection extends SmartMoverApiCollection<IReportServiceCategory> implements IApiCollection<IReportServiceCategory> {

        protected get smartMoverHiddenValue() {
            return this.options.hiddenValue || SmartMoverHiddenValue.EmptyArray;
        }

        get url() {
            return 'report/ServiceCategory';
        }
    }

}